import { type FC } from 'react';
import {
  FlagCheckered
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconFlagCheckeredProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconFlagCheckered: FC<UiIconFlagCheckeredProps> = (props) => {
  return (
    <UiIcon
      IconComponent={FlagCheckered}
      {...props}
    />
  );
};
